import {
  Modal,
  PrimaryButton,
  BasicButton,
  Stack,
  Text,
} from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Select,
  SelectItem,
} from "@certn/cascadia-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EmploymentVerificationRuleset } from "../types/form-values";

type SelectedValues = {
  one_instance: string;
  two_or_more_instances: string;
};

interface UnverifiedEmploymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (selectedValues: SelectedValues, type: string) => void;
  unverifiedEmploymentCountData?: EmploymentVerificationRuleset["unverified_employment_count"];
}

export function UnverifiedEmploymentModal({
  isOpen,
  onClose,
  onSave,
  unverifiedEmploymentCountData,
}: UnverifiedEmploymentModalProps) {
  const { t } = useTranslation();

  const [selectedValues, setSelectedValues] = useState<SelectedValues>({
    one_instance: unverifiedEmploymentCountData?.one_instance || "REVIEW",
    two_or_more_instances:
      unverifiedEmploymentCountData?.two_or_more_instances || "REVIEW",
  });

  return (
    <Modal isOpen={isOpen} testID="unverified-employment-modal">
      <Dialog width="480px">
        <DialogHeader onClose={onClose}>
          {t("Unverified Employment Count")}
        </DialogHeader>
        <DialogContent>
          <Stack gap="space-4">
            <Text style="global/body-primary">
              {t(
                "Select outcomes based on how many employments could not be verified (e.g., no response, company closed)."
              )}
            </Text>
            <Select
              label={t("1 Unverified")}
              testID="unverified-employment-outcome-select"
              selectedKey={selectedValues.one_instance}
              onSelectionChange={(value) =>
                setSelectedValues({
                  ...selectedValues,
                  one_instance: value as string,
                })
              }
            >
              <SelectItem id="REVIEW">{t("Review")}</SelectItem>
              <SelectItem id="CLEAR">{t("Clear")}</SelectItem>
              <SelectItem id="CRITERIA_NOT_MET">
                {t("Does not meet")}
              </SelectItem>
            </Select>
            <Select
              label={t("2+ Unverified")}
              testID="unverified-employment-outcome-select"
              selectedKey={selectedValues.two_or_more_instances}
              onSelectionChange={(value) =>
                setSelectedValues({
                  ...selectedValues,
                  two_or_more_instances: value as string,
                })
              }
            >
              <SelectItem id="REVIEW">{t("Review")}</SelectItem>
              <SelectItem id="CLEAR">{t("Clear")}</SelectItem>
              <SelectItem id="CRITERIA_NOT_MET">
                {t("Does not meet")}
              </SelectItem>
            </Select>
          </Stack>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose} testID="cancel-button">
            {t("Cancel")}
          </BasicButton>
          <PrimaryButton
            onPress={() => {
              onSave(selectedValues, "unverified_employment_count");
              onClose();
            }}
            testID="save-button"
          >
            {t("Set")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
